import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GlobalFunctions } from 'app/content/libs/global-functions';

@Component({
  selector: 'app-agb',
  templateUrl: './agb.component.html',
  styleUrls: ['./agb.component.less']
})
export class AgbComponent {

  hash: string = undefined;
  scrollDuration = 500;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.getHash() != undefined && this.getHash().trim().length > 0) {
          this.scrollToElement('#' + this.getHash(), this.scrollDuration);
        }
      }
    });
    this.route.fragment.subscribe((fragment: string) => {
      this.hash = fragment;
      //console.log("hash: "+fragment);
    })
  }
  getHash(): string {
    return this.hash;
  }

  public scrollToElement(id: string, duration: number): void {
    GlobalFunctions.scrollToElement(id, duration);
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/agb/agb.component.ts